import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ArrowUp } from "lucide-react";

/**
 * Mount once at the App root. Scrolls the window to the top whenever the
 * pathname changes — but leaves hash navigation (e.g. /#features) alone so
 * the home page's anchor-scroll behavior keeps working.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

/**
 * Floating action button — appears in the bottom-right corner after the user
 * has scrolled past 400px. Visible across the entire app (marketing + product).
 */
export function ScrollTopButton() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;
  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      data-testid="scroll-to-top-button"
      aria-label="Scroll to top"
      className="fixed bottom-5 right-5 z-50 inline-flex items-center justify-center w-11 h-11 bg-black text-white border border-black shadow-[3px_3px_0_0_#000000] hover:bg-[#1F1F1F] transition-colors"
    >
      <ArrowUp size={16} />
    </button>
  );
}
